<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة نشرة عقارية</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/latestNews">النشرات العقارية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <LatestNewsForm card-title="إضافة نشرة عقارية جديدة" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import LatestNewsForm from './form.vue';

export default {
  name: 'LatestNewsCreate',
  components: { LatestNewsForm },
};
</script>